export default class BranchActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_BRANCH='GET_HELPER_BRANCH';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: BranchActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: BranchActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: BranchActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: BranchActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: BranchActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: BranchActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: BranchActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: BranchActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: BranchActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: BranchActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: BranchActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: BranchActions.GET_HELPER_BRANCH,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: BranchActions.ERROR_SERVER,
      payload: error
    };
  }
}